var UIModelWabaPolicyViolations = /** @class */ (function () {
    function UIModelWabaPolicyViolations(response) {
        this.total = response.total;
        this.wabaPolicyViolation = response.wabaPolicyViolations.map(function (wabaPolicyViolation) {
            return new UIModelWabaPolicyViolation(wabaPolicyViolation);
        });
    }
    return UIModelWabaPolicyViolations;
}());
export { UIModelWabaPolicyViolations };
var UIModelWabaPolicyViolation = /** @class */ (function () {
    function UIModelWabaPolicyViolation(response) {
        var _this = this;
        this.update = function (response) {
            _this.createdAt = response.createdAt;
            _this.event = response.event;
            _this.expiresAt = response.expiresAt || null;
            _this.id = response.id;
            _this.modifiedAt = response.modifiedAt;
            _this.payload = new UIModelPayload(response.payload);
            _this.type = response.type;
            _this.wabaAccountId = response.wabaAccountId;
        };
        this.update(response);
    }
    return UIModelWabaPolicyViolation;
}());
export { UIModelWabaPolicyViolation };
var UIModelPayload = /** @class */ (function () {
    function UIModelPayload(response) {
        this.event = response.event;
        this.phoneNumber = response.phoneNumber || null;
        this.restrictionInfo = response.restrictionInfo
            ? response.restrictionInfo.map(function (restrictionInfo) { return new UIModelRestrictionInfo(restrictionInfo); })
            : null;
        this.violationInfo = response.violationInfo
            ? new UIModelViolationInfo(response.violationInfo)
            : null;
        this.wabaAccountId = response.wabaAccountId;
    }
    return UIModelPayload;
}());
export { UIModelPayload };
var UIModelRestrictionInfo = /** @class */ (function () {
    function UIModelRestrictionInfo(response) {
        (this.expiration = response.expiration),
            (this.restrictionType = response.restrictionType);
    }
    return UIModelRestrictionInfo;
}());
export { UIModelRestrictionInfo };
var UIModelViolationInfo = /** @class */ (function () {
    function UIModelViolationInfo(response) {
        this.violationType = response.violationType;
    }
    return UIModelViolationInfo;
}());
export { UIModelViolationInfo };
//# sourceMappingURL=data:application/json;base64,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